import { z } from "zod";
/**
 * The minimal DNA shape — `{ bpm, key, mood }` — shared by every DNA event
 * (`DNAReferenceAttached`, `ReferenceUploaded`, `ReferenceAnalyzed`) and by the
 * pure DNA helpers (`renderDnaReference`, `blendDnaReferences`). Spec §4.1: the
 * `bpm/key/mood` triple is extracted once here and reused, instead of being
 * re-declared per event.
 */
export const dnaCoreSchema = z.object({
    bpm: z.number().positive().max(300),
    key: z.string().min(1),
    mood: z.string().min(1),
});
//# sourceMappingURL=schema.js.map